// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"103":"forum/pages/discussions/PrivateDiscussionComposer","274":"forum/pages/PrivateDiscussionsUserPage","682":"forum/components/PrivateComposerPage","859":"forum/modals/AddRecipientModal","900":"forum/modals/ByobuTagDiscussionModal"}[chunkId] + ".js";
};